import styles from './GuestListType.style';
import ButtonCheckin from '../ButtonCheckin/ButtonCheckin';
import { useCallback, useContext } from 'react';
import { LanguageContext } from '../../shared/contexts/Language.context';
import { ThemeContext } from '../../shared/contexts/Theme.context';
import GuestAdvice from '../GuestAdvice/GuestAdvice';

export default function GuestListType({ guests, type, onClick, booking, disabled = false }) {
  const {
    actions: { translate },
  } = useContext(LanguageContext);

  const { state: theme } = useContext(ThemeContext);
  const { className: themeClassName, styles: themeStyle } = styles(theme);

  const handleClick = useCallback(
    ({ id, finished }) => {
      if (!finished && !disabled) onClick(id);
    },
    [disabled]
  );
  const typeText = translate(`type.${type}`);

  return (
    <>
      <h4 className={`${themeClassName} form-title`}>{`${translate('checkIn')} ${typeText}`}</h4>
      <GuestAdvice adviceKey={type == 'adults' ? 'adults-desc' : 'children-desc'} />
      {
        <div>
          {guests.map(
            ({ id, guest, finished, holder, review = false, checkinCompletedActionUrl }, idx) => {
              finished = review ? false : finished;
              return (
                <ButtonCheckin
                  key={id}
                  name={getName({
                    guest,
                    isHolder: holder,
                    typeText: translate(`type.${type == 'adults' ? 'adult' : 'child'}`),
                    idx,
                  })}
                  icon={type}
                  onClick={() => handleClick({ id, finished })}
                  finished={review ? false : finished}
                  disabled={disabled}
                  reviewAdvice={review}
                  checkinCompletedActionUrl={checkinCompletedActionUrl}
                />
              );
            }
          )}
        </div>
      }

      {themeStyle}
    </>
  );

  /**
   * @param {Object} params
   * @param {Object} params.guest - Guest data
   * @param {boolean} params.isHolder - Is the holder of the booking?
   * @param {string} params.typeText - Type of guest
   * @param {number} params.idx - Index of the guest in the list
   * @returns {string} The constructed name or a default name based on input parameters
   */
  function getName({ guest, isHolder, typeText, idx }) {
    // Define the guest name if available
    const { name, surname } = guest || {};
    const guestFullName = `${name || ''} ${surname || ''}`.trim();
    // Define the holder name if available
    const holderFullName = `${booking.holder || ''}`.trim();

    // If the current guest was registered previously and it had a name, return it
    if (guestFullName) return guestFullName;
    // If the current guest is the holder and it has a name, return it
    else if (isHolder && holderFullName) return holderFullName;

    // In any other case, return a default name
    return `${typeText} ${idx + 1}`;
  }
}
